import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Reset scroll on route change. Sticky navbar excluded (window-level only).
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}
